export enum AccessLevel {
  BASIC = 1,
  ACCOUNTING = 2,
  ADMIN = 3,
}

export const accessLevels = {
  [AccessLevel.BASIC]: {
    name: getLevelName(AccessLevel.BASIC),
    description:
      "User can only access basic tools to view jobsite, visit details, view and submit requests",
  },
  [AccessLevel.ACCOUNTING]: {
    name: getLevelName(AccessLevel.ACCOUNTING),
    // eslint-disable-next-line max-len
    description:
      "Includes all Basic accesses, ability to manage profile, view invoices and transactions, complete payments, view and approve estimates from your contractor",
  },
  [AccessLevel.ADMIN]: {
    name: getLevelName(AccessLevel.ADMIN),
    description:
      "Has no restrictions. Includes all Accounting accesses, and can operate users and roles",
  },
};

export function getLevelName(accessLevel: AccessLevel): string {
  return AccessLevel[accessLevel].toLowerCase();
}

export function hasAccess(
  allowedRoles: Array<AccessLevel>,
  role: AccessLevel,
): boolean {
  return allowedRoles.includes(role);
}

export function getAccessLevels(): Array<number> {
  const keys = Object.keys(AccessLevel).map((key) => +key);

  return keys.slice(0, keys.length / 2);
}
